import loadable from '@loadable/component';
import { advancedListingSchema } from './AdvancedListingSchema';
import { advancedCarouselSchema } from './AdvancedCarouselSchema';
import { advancedCitationSchema } from './AdvancedCitationSchema';

// Dynamically import components using loadable
const LazyAdvancedListingBlockTemplate = loadable(() =>
  import('./AdvancedListingBlockTemplate'),
);
const LazyAdvancedCarouselBlockTemplate = loadable(() =>
  import('./AdvancedCarouselBlockTemplate'),
);
const LazyAdvancedCitationBlockTemplate = loadable(() =>
  import('./AdvancedCitationBlockTemplate'),
);

const applyConfig = (config) => {
  config.blocks.blocksConfig.listing.variations = [
    {
      id: 'advanced',
      title: 'Advanced Listing',
      template: LazyAdvancedListingBlockTemplate,
      schemaEnhancer: advancedListingSchema,
    },
    {
      id: 'advancedCarousel',
      title: 'Advanced Carousel',
      template: LazyAdvancedCarouselBlockTemplate,
      schemaEnhancer: advancedCarouselSchema,
    },
    {
      id: 'advancedCitation',
      title: 'Advanced Citation',
      template: LazyAdvancedCitationBlockTemplate,
      schemaEnhancer: advancedCitationSchema,
    },
    ...config.blocks.blocksConfig.listing.variations,
  ];
  return config;
};

export default applyConfig;
